import React from 'react';
import { IconButton } from './IconButton';

interface TableItemProps {
  readonly?: boolean;
  children: React.ReactNode[] | React.ReactNode;
  expanded?: boolean;
  remove?: () => void;
  onExpandClicked?: () => void;
}

export const TableItem = ({ children, readonly, expanded, remove, onExpandClicked }: TableItemProps) => {
  return (
    <div className="grid grid-cols-12 grid-rows-1 pb-2">
      <div className={remove && !readonly && onExpandClicked ? 'col-span-10' : 'col-span-11'}>
        <div className={`grid grid-flow-col auto-cols-fr items-start`}>{children}</div>
      </div>
      {!readonly && remove && (
        <div className="-col-start-1 col-span-1 flex flex-row justify-center items-center">
          <IconButton icon="/delete.svg" onClick={remove} />
        </div>
      )}
      {onExpandClicked && (
        <div className="-col-start-1 col-span-1 flex flex-row justify-center items-center">
          {expanded ? (
            <IconButton icon="/arrowUp.svg" onClick={onExpandClicked} />
          ) : (
            <IconButton icon="/arrowDown.svg" onClick={onExpandClicked} />
          )}
        </div>
      )}
    </div>
  );
};
